var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGraph(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9999 29.9999C23.2842 29.9999 29.9999 23.2842 29.9999 14.9999C29.9999 6.7157 23.2842 0 14.9999 0C6.7157 0 0 6.7157 0 14.9999C0 23.2842 6.7157 29.9999 14.9999 29.9999Z",
    fill: "#B7B7B7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6638 6.4422L21.0751 5.85351L19.7878 6.37218L20.8848 7.46923L17.4747 10.8793L13.9142 7.31882L11.3236 9.90947L7.43595 6.02185L6.33926 7.11855L7.27365 8.05294L6.33926 8.98733V22.4218L7.02222 23.1047L6.15381 23.9732L11.8482 29.6676C12.8646 29.8848 13.9188 30.0003 15.0001 30.0003C23.2843 30.0003 30 23.2846 30 15.0003C30 14.1049 29.9212 13.228 29.7708 12.3757L22.7505 5.35547L21.6638 6.4422Z",
    fill: "#959595"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2588 10.4414H22.8233V23.332H20.2588V10.4414Z",
    fill: "#E9EDF5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4121 13.4883H18.9766V23.332H16.4121V13.4883Z",
    fill: "#E9EDF5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5654 11.0859H15.1299V23.332H12.5654V11.0859Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.71875 15.0117H11.2832V23.332H8.71875V15.0117Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.43607 22.6895V6.02051H6.15381V22.6895V23.9717H7.43607H15.7706L16.4117 23.3306L15.7706 22.6895H7.43607Z",
    fill: "#324380"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7705 22.6903H24.105V23.9725H15.7705V22.6903Z",
    fill: "#202C58"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8075 6.35449L8.83154 12.6477L9.52095 13.1928L13.8857 7.67261L15.77 9.54854L16.1551 9.25136L15.77 8.30835L13.8075 6.35449Z",
    fill: "#324380"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.919 6.90644L21.9794 8.39132L22.8367 7.46085L22.7504 5.35547L20.645 5.44166L19.7877 6.37213L21.2726 6.31089L17.6801 10.2102L15.7705 8.30893V9.54912L17.7075 11.4776L21.919 6.90644Z",
    fill: "#202C58"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph);
export default __webpack_public_path__ + "static/media/graph.9a232597e980f583e97ae8fdca2493b4.svg";
export { ForwardRef as ReactComponent };